<template>
    <form-group :validator="v" :label="label" :label-for="id" :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <v-select :id="id"
                :inputId="id"
                :options="options"
                :value="value"
                aria-label="Search for position location" 
                screenreader="Search for position location" 
                @input="onSelected"
                :data-test="slug"
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                v-on="listeners">
                <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!v.required"
                        v-bind="attributes"
                        v-on="events"
                        :state="v.$dirty ? !v.$error : null"
                        />
                </template>
            </v-select>            
        </template>
    </form-group>
</template>

<script>
import _ from "lodash"

export default {
    props: {
        value: [String],
        label: [String],
        tip: [String],
        slug: [String],
        required: [Boolean],
        v: [Object],
        cid: [String]
    },
    data() {
        return {
            options: [ "Freeman Building",
                        "Golden Rule Building",
                        "MDH Lab Building",
                        "Bemidji, Northwestern District",
                        "Duluth, Northeastern District",
                        "Fergus Falls, West Central District",
                        "Mankato, South Central District",
                        "Marshall, Southwestern District",
                        "Rochester, Southeastern District",
                        "St. Cloud, Central District",
                        "Other"
                    ],
            defaultSelection: ''
        } 
    },
    computed: {
        id() {
            if (this.cid) {
                return this.cid
            } else {
                return _.uniqueId('locationSelector')
            }
        },
    },
    methods: {
        onSelected(item) {
            this.$emit('input', item)
        }, 
  }
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
.vs__spinner {
    font-size: 1em;
}
</style>